import clsx from "clsx";
import { useId } from "react";

type LogoProps = {
  className?: string;
};

const Logo = ({ className }: LogoProps) => {
  const clipPathId = useId();

  return (
    <svg
      className={clsx("h-[18px] w-auto", className)}
      viewBox="0 0 59 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M58.5014 17.644H55.0938V1.0202H58.5014V17.644Z"
          fill="#0062E2"
        />
        <path
          d="M51.5989 4.0362C50.4391 4.0362 49.5625 3.13244 49.5625 2.01642C49.5625 0.900409 50.4391 -0.00335693 51.5989 -0.00335693C52.7587 -0.00335693 53.6353 0.900409 53.6353 2.01642C53.6353 3.13244 52.7348 4.0362 51.5989 4.0362ZM53.3045 17.644H49.9207V5.77184H53.3045V17.644Z"
          fill="#0062E2"
        />
        <path
          d="M41.0629 17.9282C38.508 17.9282 36.9219 16.552 36.9219 14.3439C36.9219 11.8757 39.006 11.2561 40.9674 10.8521L42.2704 10.5919C43.8566 10.2838 44.8492 10.0681 44.8492 8.90421C44.8492 7.88405 44.0203 7.4082 42.98 7.4082C41.9396 7.4082 41.0629 7.83612 40.9913 9.02402H37.4199C37.5393 6.53182 39.6917 5.39185 43.0277 5.39185C44.6377 5.39185 45.7736 5.67598 46.5991 6.15183C47.9942 7.00767 48.2091 8.38386 48.2091 9.78401V15.6722C48.2091 16.4561 48.233 17.1203 48.2808 17.644H44.9209V16.0282C44.2591 17.0244 43.171 17.9282 41.0629 17.9282ZM42.3864 15.6961C43.8771 15.6961 44.8015 14.7239 44.8015 13.2279V11.7319C44.5183 11.9441 43.7372 12.1838 43.0277 12.3721L42.673 12.4679C41.4177 12.8 40.5444 13.0362 40.5444 14.1077C40.5444 15.0799 41.2062 15.6996 42.3898 15.6996L42.3864 15.6961Z"
          fill="#0062E2"
        />
        <path
          d="M27.6019 11.4683V8.80834H36.0716V17.6406H33.0187V15.5968C32.0943 16.9251 30.5593 17.9966 28.1204 17.9966C23.4369 17.9966 20.5 14.5527 20.5 9.28076C20.5 4.00879 23.8156 0.640213 28.6661 0.640213C32.5241 0.640213 35.2188 2.49225 35.884 5.53219H32.0977C31.6952 4.06014 30.3955 3.15638 28.69 3.15638C26.0157 3.15638 24.2897 5.36444 24.2897 9.30815C24.2897 13.2519 26.0157 15.4839 28.7378 15.4839C31.0573 15.4839 32.5002 13.9639 32.6673 11.4717H27.6053L27.6019 11.4683Z"
          fill="#0062E2"
        />
        <path
          d="M11.5469 6.31611V12.372L17.5811 6.31611V0.260193L11.5469 6.31611Z"
          fill="#0062E2"
        />
        <path
          d="M5.51486 12.372C3.85025 10.7014 3.85025 7.98669 5.51486 6.3161C6.35057 5.47738 7.44212 5.05973 8.53366 5.05973V0.780533C6.35057 0.780533 4.16407 1.61925 2.49947 3.28985C-0.833156 6.63447 -0.833156 12.0571 2.49947 15.4051C5.83209 18.7497 11.2352 18.7497 14.5713 15.4051L11.5525 12.3754C9.88786 14.046 7.18288 14.046 5.51827 12.3754L5.51486 12.372Z"
          fill="#0062E2"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="58.5" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Logo;
